<template>
  <div class="py-8">
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link class="text-decoration--none" :to="{ name: 'users' }"
          >Users</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4">
      <v-row no-gutters>
        <v-col cols="12" sm="8" flex>
          <div
            class="display-name display-2 font-weight-light mb-10 font-serif text-capitalize"
          >
            {{ displayName }}
          </div>
        </v-col>
        <v-col cols="12" sm="4" flex class="text-right">
          <block-form :user="user" />
        </v-col>
      </v-row>

      <div class="d-flex my-6">
        <v-tabs v-model="tabIndex" hide-slider class="user-info-tabs">
          <v-tab
            v-for="(item, key) in tabItems"
            :key="key"
            @click="setTab(key)"
          >
            {{ item.tab }}
          </v-tab>

          <v-tab-item class="col-md-12 col-sm-12 col-xs-12 mt-6 pa-0">
            <user-form ref="userForm" :user="user" />
          </v-tab-item>
          <v-tab-item class="col-md-12 col-sm-12 col-xs-12 mt-6 pa-0">
            <verification-id-form v-if="user" :user="user" />
          </v-tab-item>
          <v-tab-item class="col-md-12 col-sm-12 col-xs-12 mt-6 pa-0">
            <job-list v-if="user" :user="user" />
          </v-tab-item>
          <v-tab-item class="col-md-12 col-sm-12 col-xs-12 mt-6 pa-0">
            <transaction-list v-if="user" :user="user" />
          </v-tab-item>
        </v-tabs>
      </div>
    </div>

    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import {
  mdiChevronLeft,
  mdiCheck,
  mdiAlertCircleOutline,
  mdiAccountOff
} from '@mdi/js'
import { mapState, mapActions, mapMutations } from 'vuex'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import UserForm from '@/views/Home/Users/components/UserForm'
import VerificationIdForm from '@/views/Home/Users/components/VerificationIdForm'
import BlockForm from '@/views/Home/Users/components/BlockForm'
import JobList from '@/components/lists/JobList'
import TransactionList from '@/components/lists/TransactionList'

const HASH = ['#info', '#IDs', '#tools', '#transactions']

export default {
  name: 'UserDetails',

  components: {
    UserForm,
    BlockForm,
    AppBarNavIcon,
    JobList,
    TransactionList,
    VerificationIdForm
  },

  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft,
        check: mdiCheck,
        alert: mdiAlertCircleOutline,
        block: mdiAccountOff
      },
      loading: false,
      tabIndex: 0,
      tabItems: [
        { tab: 'Info' },
        { tab: 'IDs' },
        { tab: 'Tools' },
        { tab: 'Transactions' }
      ]
    }
  },

  computed: {
    ...mapState({
      user: state => state.user.userDetails
    }),

    displayName() {
      if (!this.user) return ''
      return this.user.full_name || this.user.email
    }
  },

  watch: {
    $route() {
      this.getUser()
    }
  },

  methods: {
    ...mapActions({
      getUserDetails: 'user/getUserDetails'
    }),

    ...mapMutations({
      clearUserDetails: 'user/clearUserDetails'
    }),

    async getUser() {
      this.loading = true
      await this.getUserDetails(this.$route.params.id)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          if (error.response && error.response.status === 404) {
            this.$refs.userForm.showSnackbar(
              'Fail to fetch user details! User may be invalid or does not exist anymore',
              'danger'
            )
          } else {
            this.$refs.userForm.showSnackbar(
              error.response.data.message,
              'danger'
            )
          }

          this.loading = false
        })
    },

    setTab(index) {
      this.$router.push({
        name: 'user.details',
        hash: HASH[index]
      })
    }
  },

  created() {
    this.tabIndex = HASH.indexOf(this.$route.hash)
    this.getUser()
  },

  destroyed() {
    this.clearUserDetails()
  }
}
</script>
<style type="text/css">
.display-name {
  overflow-wrap: break-word;
}
</style>
